// @flow
import React from 'react'
import { CheckedBar } from '../../../Bars/'

type SelectedRowProps = {
  selected: Object | null,
  textMaxLength: number,
  highestNumber: number,
  fields: Array<Object>,
  type: string
}

export const SelectedRow = ({
  selected,
  textMaxLength,
  highestNumber,
  fields,
  type
}: SelectedRowProps) => {
  if (!selected) return null

  return (
    <CheckedBar
      data={selected}
      textOffset={textMaxLength}
      highestNumber={highestNumber}
      selected={selected}
      fields={fields}
      type={type}
      accent
    />
  )
}



// WEBPACK FOOTER //
// ./src/shared/components/Main/Rows/TopRows/SelectedRow.js